import React from "react";
import PropTypes from "prop-types";
import Link from "@/components/Link";
import BigMessage from "@/components/BigMessage";
import NoTaggedObjectsFound from "@/components/NoTaggedObjectsFound";
import EmptyState, { EmptyStateHelpMessage } from "@/components/empty-state/EmptyState";
import DynamicComponent from "@/components/DynamicComponent";
import { currentUser } from "@/services/auth";
import HelpTrigger from "@/components/help-trigger/HelpTrigger";

export default function IndexerListEmptyState({ page, searchTerm, selectedTags }) {
  if (searchTerm !== "") {
    return <BigMessage message="Sorry, we couldn't find anything." icon="fa-search" />;
  }

  if (selectedTags.length > 0) {
    return <NoTaggedObjectsFound objectType="indexer" tags={selectedTags} />;
  }

  switch (page) {
    case "favorites":
      return <BigMessage message="Mark indexers as Favorite to list them here." icon="fa-star" />;
    case "archive":
      return <BigMessage message="Archived indexers will be listed here." icon="fa-archive" />;
    case "my":
      const myMessage = currentUser.hasPermission("list_indexers") ? (
        <span>
          <Link.Button href="indexers/new" type="primary" size="small">
            Create your first indexer !
          </Link.Button>{" "}
          <HelpTrigger className="f-13" type="INDEXERS" showTooltip={false}>
            Need help?
          </HelpTrigger>
        </span>
      ) : (
        <span>Sorry, we couldn't find anything.</span>
      );
      return <BigMessage icon="fa-search">{myMessage}</BigMessage>;
    default:
      return (
        <DynamicComponent name="IndexersList.EmptyState">
          <EmptyState
            icon="fa fa-database"
            illustration="indexer"
            description="Building and managing your data indexers."
            helpMessage={<EmptyStateHelpMessage helpTriggerType="ALERTS" />}
          />
        </DynamicComponent>
      );
  }
}

IndexerListEmptyState.propTypes = {
  page: PropTypes.string.isRequired,
  searchTerm: PropTypes.string.isRequired,
  selectedTags: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
};
